import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, structuredData, canonical, image }) => {
    const siteTitle = 'SprawdzStatus.pl';
    const defaultDescription = 'System monitorowania zleceń i śledzenia statusu zadań. Wysyłaj unikalne linki pracownikom i podwykonawcom. Śledź statusy zleceń, zbieraj zdjęcia i dowody realizacji. Bez instalacji aplikacji. Wypróbuj za darmo.';
    const defaultImage = 'https://sprawdzstatus.pl/social-v2.png'; // Updated social image URL

    const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
    const finalDescription = description || defaultDescription;
    const finalImage = image || defaultImage;
    const currentUrl = canonical || (typeof window !== 'undefined' ? window.location.href : '');

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={finalDescription} />
            {keywords && <meta name="keywords" content={keywords} />}

            {/* Canonical URL */}
            {currentUrl && <link rel="canonical" href={currentUrl} />}

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={finalDescription} />
            <meta property="og:site_name" content={siteTitle} />
            <meta property="og:image" content={finalImage} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={finalDescription} />
            <meta name="twitter:image" content={finalImage} />

            {structuredData && (
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;
